import {MMQueryOptions} from 'lionheartland';


export class SODeleteDatafeed {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
